import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _CostingCenter } from '../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_md } from '../../../theme/Component/hooks/useModal';
import { BasicTable, MASK_NUMBER } from '../../../theme/Component/BasicTable';
import { Modal } from '../../../theme/Component/Modal';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const EditorCostingCenter = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_CostingCenter)
    const [id, setID] = useState(null);

    const modal = useModal("Centro de Costos", MODAL_md);

    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    useEffect(() => {
        getLista();
    }, [])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.Code == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };




    const getLista = () => {

        instance.getCostingCenterCatalog(null).then(
            (resp: any) => {
                if (resp) {
                    console.log(resp);

                    setLista(resp)
                }
            }
        ).catch(err => { console.log(err) })
    }
    const head = [
        { title: 'ID', property: 'IDCostingCenter', visible: true, mask: MASK_NUMBER },
        { title: 'Codígo', property: 'Code', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },

    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Centro de Costo"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.Code); modal.close(); }}></BasicTable>
            </Modal>
        </>
    )
}